// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gfA4BvygM1mXK2 {
  display: flex;
  flex-direction: column;
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: var(--ds-space-100, 8px);
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t {
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: unset;
  color: var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_:hover,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t:hover,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_:focus,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t:focus,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_.FbPsA3vBIQabhF,
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t.FbPsA3vBIQabhF {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .W4U9_6TF0Qd8V_ {
  margin-left: var(--ds-space-100, 8px);
}
.gfA4BvygM1mXK2 .HIzUUSl_mlCMv8 .KrvmSqW5kDgs2t {
  transform: rotate(180deg);
}
`, ""]);
// Exports
export var feedbackCollectorContainer = `gfA4BvygM1mXK2`;
export var feedbackButtonsContainer = `HIzUUSl_mlCMv8`;
export var positiveFeedbackButton = `W4U9_6TF0Qd8V_`;
export var negativeFeedbackButton = `KrvmSqW5kDgs2t`;
export var selected = `FbPsA3vBIQabhF`;
export default ___CSS_LOADER_EXPORT___;
